import Image from 'next/image';
import UserImagesCustomSection from './UserImagesCustomSection';

export default function ImageGalleryThumbs(props) {
  const {
    item,
    productName,
    user_review_images,
    product,
    total_count_images,
    parent,
  } = props;
  return (
    <>
      {item.type === 'custom' ? (
        <div className="image-gallery-thumbnail-inner">
          <UserImagesCustomSection
            user_review_images={user_review_images}
            showCta={false}
            product={product}
            index={item.index}
            total_count_images={total_count_images}
            parent={parent}
          />
        </div>
      ) : item.thumbnail == 'video' ? (
        <span className="image-gallery-thumbnail-inner">
          <div>
            <img
              className="ThumbPlayButton"
              src="/images/video_play.svg"
              alt="video_play_button"
            />
          </div>
          <Image
            className="image-gallery-thumbnail-image"
            src={item?.videoThumbnail}
            alt={productName}
            quality={90}
            fill
            sizes="10vw"
          />
        </span>
      ) : (
        <span className="image-gallery-thumbnail-inner">
          <Image
            className="image-gallery-thumbnail-image"
            src={item?.thumbnail}
            alt={productName}
            fill
            sizes="10vw"
          />
        </span>
      )}
    </>
  );
}
